/**
 * Third party imports
 */
import moment from 'moment';
import 'moment-timezone';
import { primary, secondary } from 'rp-navigation';
import jQuery from 'jquery';
import { mobileDetect } from 'rp-gui-guide';
/**
 * SecondaryNavConfig
 * Configuration module for secondary navigation.
 * Builds list of items and renders whole secondary navigation.
 * @constant navState - Current state of navigation.
 *                      e.g. time-order
 * @constant GBOffset - GB offset
 */
const navState = primary.getItemByTitle('Results').stateManager.prevState;
const GBOffset = moment().tz('Europe/London').utcOffset();
/**
 * Forms correct link for specific date.
 * @param date - date, that should be reflected in link
 * @param isToday - flag, determining whether passed date is for today
 * @returns {string} - url
 */
function getListResultsLink(date, isToday) {
    const state = (navState && navState.hasOwnProperty('path')) ? `/${navState.path}` : '';
    if (isToday) {
        return state ? state.replace('/', '') : '.';
    }
    return `${date.format('YYYY-MM-DD')}${state}`;
}
/**
 * Method to calculate the date of "now", in GB timezone.
 * @returns {Moment|number|*}
 */
function getGBDate() {
    const localOffset = GBOffset - moment().utcOffset();
    return moment().add(localOffset, 'm');
}
/**
 * Forms list of dates for secondary navigation menu.
 * @param date - active date, that should be highlighted
 * @returns {*[]} - array of secondary navigation items
 */
function getDateList(date) {
    const daysCount = 7;
    const today = getGBDate();
    const lastDate = today.clone().subtract(daysCount, 'days');
    const activeDate = date ? moment(date) : today;
    const yesterday = today.clone().subtract(1, 'days');
    const isYesterday = activeDate.isSame(yesterday, 'day');
    let isSelectedKnown = !date || isYesterday;
    const dates = [
        {
            name: 'Today',
            url: getListResultsLink(today, true),
            isActive: !date || activeDate.isSame(today, 'day'),
            class: ''
        },
        {
            name: 'Yesterday',
            url: getListResultsLink(yesterday),
            isActive: isYesterday,
            class: ''
        }
    ];

    if (!lastDate.isBefore(activeDate)) {
        isSelectedKnown = true;
        dates.unshift({
            name: activeDate.format('ddd, D MMM, YYYY'),
            url: getListResultsLink(activeDate),
            isActive: true,
            class: 'hp-headerMenuItem_fromMedium'
        });
    }
    for (let i = 2; i < daysCount; i++) {
        const listDate = today.clone().subtract(i, 'days');

        dates.push({
            name: listDate.format('ddd D'),
            url: getListResultsLink(listDate),
            isActive: !isSelectedKnown && activeDate.isSame(listDate, 'day'),
            class: ''
        });
    }

    return dates;
}
/**
 * Setter of item for secondary navigation.
 * @param item
 * @param index - item's index
 * @param array - all items
 */
function setSecondaryItem(item, index, array) {
    const outOfRange = array.length === 8;
    secondary
        .addItem(
            item.name,
            item.url,
            '',
        {
            target: '_self',
            class: item.class,
            'data-test-selector': `link-secondaryMenuDay${outOfRange ? index : index + 1}`
        }
        );
    if (item.isActive) {
        const activeItem = secondary.getItemByTitle(item.name);
        secondary.setActiveItem(activeItem);
    }
}
/**
 * Removes placeholder (empty) item from initial secondary navigation.
 */
function removePlaceholderItem() {
    const item = secondary.getItemByPosition(0);

    secondary.removeItem(item);
}
/**
 * Renders secondary navigation
 */
export default function renderSecondaryNav() {
    const isFullResult = (/\/(results|fast-results)\/\d*\//).test(window.location.pathname);
    const isMobile = mobileDetect.mobile();
    const isFullMobile = isMobile && isFullResult;
    const showSecondary = !isFullResult || isMobile;
    const dateRegex = isFullMobile ? /^(\/results\/|\/fast-results\/)[\d]*\/[\w|-]*\/([\d|-]*)\//g :
                                    /^(\/results\/|\/fast-results\/)([\d|-]*)\/?(.*)/g;

    if (showSecondary) {
        const parsedPath = dateRegex.exec(window.location.pathname);
        const pageDate = parsedPath[2];
        const dateList = getDateList(pageDate);

        removePlaceholderItem();
        dateList.forEach(setSecondaryItem);

        secondary
            .addItem(
                'Select Date',
                '',
                '',
            {
                'data-date': pageDate,
                'data-directive-select-date': '',
                'data-test-selector': 'link-secondaryMenuDatePicker',
            })
            .addItem(
                'Advanced Results Search',
                '',
                '',
            {
                'data-directive-advanced-search': '',
                'data-test-selector': 'link-advancedSearch',
            })
            .render();

        if (isFullMobile) {
            jQuery('.js-secondary')
                .slideDown(300)
                .removeClass('ui-secondaryNavigation_hidden');
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/services/secondaryNavConfig.js